export const modeToValueMap = {
	external: 'External',
	internal: 'Internal'
};
